import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiVideo, FiTrendingUp, FiTarget, FiBookOpen } = FiIcons;

const features = [
  {
    icon: FiVideo,
    title: 'Record & Analyze',
    description: 'Film your match with your phone. Our AI watches it for you and breaks down every shot, serve, and mistake — no coaching experience needed.',
    color: 'bg-primary/10 text-primary',
    tag: 'Most Popular'
  },
  {
    icon: FiTarget,
    title: 'Drills Made for You',
    description: 'Get a short list of drills built around your actual weaknesses. No generic advice — just the stuff that will move the needle for your game.',
    color: 'bg-teal/10 text-teal',
    tag: null
  },
  {
    icon: FiBookOpen,
    title: 'Learn in the Classroom',
    description: 'Watch bite-sized video lessons on strategy, technique, and court positioning. Learn at your own pace, anytime, anywhere.',
    color: 'bg-amber/10 text-amber-dark',
    tag: null
  },
  {
    icon: FiTrendingUp,
    title: 'Track Your Progress',
    description: 'See how far you\'ve come. Your stats, scores, and improvement trends are all in one place so you always know where you stand.',
    color: 'bg-utility-info/10 text-utility-info',
    tag: null
  },
];

const Features = () => {
  return (
    <section id="features" className="py-20 bg-neutral-surface border-y border-neutral-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-primary font-semibold tracking-wide uppercase text-sm mb-3">Everything in One App</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-text-primary mb-5">Your complete pickleball toolkit</h3>
          <p className="text-text-secondary text-lg">
            From your first match recording to your hundredth drill — we've got everything you need to keep getting better.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-neutral-bg rounded-2xl p-6 border border-neutral-border hover:shadow-soft transition-all hover:-translate-y-1 group relative"
            >
              {feature.tag && (
                <span className="absolute -top-3 left-6 bg-amber text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                  {feature.tag}
                </span>
              )}
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-transform group-hover:scale-110 ${feature.color}`}>
                <SafeIcon icon={feature.icon} className="text-2xl" />
              </div>
              <h4 className="text-lg font-bold text-text-primary mb-2">{feature.title}</h4>
              <p className="text-text-secondary text-sm leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Features;